import type { KnownLocale } from "~/nvent-web/i18n";

const finishedPages: KnownLocale[] = [
  "pl",
  "en",
  "no",
  "cs",
  "fr",
  "sv",
  "fi",
  "ru",
];

export const certifiedPageFinishedForLocale = (
  locale: KnownLocale,
  isCertified: boolean
) => {
  if (locale === "sv" && !isCertified) {
    return false;
  }

  return finishedPages.includes(locale);
};
